// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBar_wrapper__vyL+0"};